import React from "react";
import "./Brands.css";
import TBC from "./TBC.jpg"

const Brands = () => {
  return <div>

<img src={TBC} alt="ToBeContinued" width="50%" height="500px"  /></div>
};

export default Brands;







